import { useState } from 'react';
import PropTypes from 'prop-types';

import { stripHTMLTags } from 'lib';

import './ReadMore.css';

const ReadMore = ({
    children,
    maxChars = 138,
    className,
    moreText,
    lessText,
}) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);

    const toggleReadMore = (event) => {
        event.stopPropagation();
        setIsReadMore(!isReadMore);
    };

    if (!text) {
        return null;
    }

    return text.length <= maxChars ? (
        <div
            className={`ab-text ${className}`}
            dangerouslySetInnerHTML={{
                __html: text,
            }}
        ></div>
    ) : (
        <div className={`ab-text ${className}`}>
            {isReadMore && <div>{stripHTMLTags(text.slice(0, maxChars))}</div>}

            {!isReadMore && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                ></div>
            )}

            <span onClick={toggleReadMore} className="ab-read-more-less">
                {isReadMore ? (
                    <>
                        <span className="ab-bold">{moreText}</span> ...
                    </>
                ) : (
                    <>
                        ... <span className="ab-bold">{lessText}</span>
                    </>
                )}
            </span>
        </div>
    );
};

ReadMore.defaultProps = {
    className: '',
    moreText: 'more',
    lessText: 'less',
};

ReadMore.propTypes = {
    children: PropTypes.string,
    maxChars: PropTypes.number,
    className: PropTypes.string,
    moreText: PropTypes.string.isRequired,
    lessText: PropTypes.string.isRequired,
};

export default ReadMore;
